import {
    Heading, 
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
} from '@chakra-ui/react'
import { TriangleUpIcon, TriangleDownIcon, InfoOutlineIcon } from "@chakra-ui/icons"
// import ServiceCoverage  from './ServiceCoverage'
// import ServiceLimits from './ServiceLimits'
import ServiceWho from './ServiceWho'
//import { Section } from 'react-stately'

function HPLSInfoAccordion () {

    return (
      <Accordion allowToggle mt={10}>
      <AccordionItem 
        id='serviceRecipientsHeader' 
        bg="black"
        border="none"
        mt={2}
      >
      {({ isExpanded }) => (
      <>
      <h2>
      <AccordionButton>
        <Box 
          as="span" 
          flex='1' 
          textAlign='left' 
          color='white'
          >
          <Heading 
            as='h4' 
            fontSize={{ base: '1rem', md: '1.2rem', lg: '1.4rem' }} 
            my={2} 
            aria-label="We offer free legal services to people who are homeless or at risk of becoming homeless. This includes people who are Sleeping Rough (for example, on the street or in a car), Couch surfing - living temporarily with friends or family due to homelessness, Living in a boarding house, hostel, or hotel, Living in social housing or private rental accommodation at risk of losing their home and becoming homeless, In public housing where housing security is at risk. If you think you are at risk of homelessness but don't fit into a category above, please call us (02) 8898 6500 for advice.">
              <InfoOutlineIcon w={5} h={5} mb={0.5} mr={1} color='piacyellow.500' /> Who can get help from HPLS 

            {isExpanded ? (
              <TriangleUpIcon w={6} h={6} float='right' />
            ) : (
              <TriangleDownIcon w={6} h={6} float='right' />
            )}
          </Heading>
        </Box>
      </AccordionButton>
      </h2>
      <AccordionPanel 
        id="serviceRecipientsPanel"
        pb={4} 
        bg='piacgray.200'
        color='black'
        borderLeft='1px' 
        borderRight='1px' 
        borderColor='gray.300'
        >
 
        <ServiceWho />

      </AccordionPanel>
      </>
      )}
    </AccordionItem>

    {/* <AccordionItem 
      id="serviceCoverageHeader"
      bg="piacgray.500"
      borderTopWidth="0px"
      borderLeftWidth="0px"
      borderRightWidth="0px"
      borderBottom="1px solid #9c9c9f"
      mt='0px'
      >
      {({ isExpanded }) => (
      <>
      <h2>
        <AccordionButton border='0px'>
          <Box as="span" flex='1' textAlign='left' color="piacgray.100">
            <Heading as='h4' size='md' aria-label="HPLS can help with FINANCIAL HARDSHIP: Credit card debts, fines, difficulty paying loans, debt collectors, helping to sort out bills with private companies. CONSUMER OR CONTRACT ISSUES: Unfair contracts, insurance, door to door sales, scams, funeral policies, superannuation. CENTRELINK: Pensions and payments, debts, fraud prosecutions. HOUSING: Eviction, repairs, rent or issues with Housing NSW/community housing, private or public housing bans from previous tenancy problems, debts that prevent getting into public housing. VIOLENCE: Victim of violence, apprehended violence orders (AVOs), victim's compensation. CRIMINAL MATTERS: Charges by police, court attendance notice, bail, seeking changes to a court order, such as bail or parole conditions. DISCRIMINATION OR HARASSMENT: Employment, education, provisions of goods and services, housing. GOVERNMENT AUTHORITIES: Complaints about police, schools, government departments. EMPLOYMENT: Loss of employment, entitlements, bullying and harassment."><InfoOutlineIcon w={5} h={5} mb={0.5} mr={1} />  What we can help with 
            {isExpanded ? (
                            <TriangleUpIcon w={6} h={6} float='right' />
                          ) : (
                            <TriangleDownIcon w={6} h={6} float='right' />
            )}
          </Heading>
          </Box>
        </AccordionButton>
      </h2>
      <AccordionPanel 
        id="serviceCoveragePanel"
        pb={4} 
        bg='piacgray.200' 
        borderLeft='1px' 
        borderRight='1px' 
        borderColor='gray.300'
        >

        <ServiceCoverage />

      </AccordionPanel>
      </>
      )}
    </AccordionItem>

    <AccordionItem 
      id='serviceLimitsHeader' 
      bg="piacgray.500" 
      borderTopWidth="0px"
      borderLeftWidth="0px"
      borderRightWidth="0px"
      borderBottom="1px solid #9c9c9f"
      mt='0px'
      >
      {({ isExpanded }) => (
      <>
      <h2>
        <AccordionButton border='0px'>
          <Box as="span" flex='1' textAlign='left' color="piacgray.100">
          <Heading as='h4' size='md' aria-label="We cannot help with the following legal matters. Family law matters such as divorce, child support, child protection, FACS matters, Visa issues, refugee applications, Disputes about property, Neighbourhood disputes, Compensation for injuries through accidents, Drafting wills. If you need help with a legal problem that we do not assist with, we recommend contacting Law Access on 1300 888 529 or your local community legal service"><InfoOutlineIcon w={5} h={5} mb={0.5} mr={1} />  What we can't help with 
            {isExpanded ? (
                            <TriangleUpIcon w={6} h={6} float='right' />
                          ) : (
                            <TriangleDownIcon w={6} h={6} float='right' />
            )}
          </Heading>
          </Box>
        </AccordionButton>
      </h2>
      <AccordionPanel 
        pb={4} 
        bg="piacgray.200" 
        borderLeft='1px' 
        borderRight='1px' 
        borderColor='gray.300'
        >
        <ServiceLimits />
      </AccordionPanel>
      </>
      )}
    </AccordionItem> */}

  </Accordion>
  )}

  export default HPLSInfoAccordion